import React from 'react';
import _ from 'lodash';
import { produce } from 'immer';
import { getVessel } from 'services/vessels/vessels';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { addVessel, saveVessel, clearVessel, updateVessel } from 'actions/vessels/vessels';
import { notificationPurposeRequired } from 'actions/vessels/size';

import { MenuItem, SelectField, TextField } from 'material-ui';
import Checkbox from 'material-ui/Checkbox';
import Toggle from 'material-ui/Toggle';
import RaisedButton from 'material-ui/RaisedButton';
import { orange500, orange900, red500 } from 'material-ui/styles/colors';

import NumberField from '../../../../../Base/NumberField';
import Name from '../../../../../Vessels/Single/Rows/Name';
import ExNames from '../../../../../Vessels/Single/Rows/ExNames';
import Nationalities from '../../../../../Vessels/Single/Rows/Nationalities';
import ImoNumber from '../../../../../Vessels/Single/Rows/ImoNumber';
import Blt from '../../../../../Vessels/Single/Rows/Blt';
import BuilderYard from '../../../../../Vessels/Single/Rows/BuilderYard';
import BuilderCountry from '../../../../../Vessels/Single/Rows/BuilderCountry';
import Flag from '../../../../../Vessels/Single/Rows/Flag';
import PortOfRegistry from '../../../../../Vessels/Single/Rows/PortOfRegistry';
import RegisterClasses from '../../../../../Vessels/Single/Rows/RegisterClasses';
import PIClub from '../../../../../Vessels/Single/Rows/PIClub';
import Manager from '../../../../../Vessels/Single/Rows/Manager';
import TypeByPurpose from '../../../../../Vessels/Single/Rows/TypeByPurpose';
import TypeByConstruction from '../../../../../Vessels/Single/Rows/TypeByConstruction';
import TypeBySize from '../../../../../Vessels/Single/Rows/TypeBySize';
import TypeBySpecialty from '../../../../../Vessels/Single/Rows/TypeBySpecialty';
import GearV2 from '../../../../../Vessels/Single/Rows/GearV2';
import GrabV2 from '../../../../../Vessels/Single/Rows/GrabV2';
import TechEquipCertificate from '../../../../../Vessels/Single/Rows/TechEquipCertificate';
import CargoExclussionsV2 from '../../../../../Vessels/Single/Rows/CargoExclussionsV2';
import Tonnage from '../../../../../Vessels/Single/Rows/Tonnage';
import Deadweight from '../../../../../Vessels/Single/Rows/Deadweight';
import CapacityV2 from '../../../../../Vessels/Single/Rows/CapacityV2';
import Dimensions from '../../../../../Vessels/Single/Rows/Dimensions';
import HoldsHatchesTop from '../../../../../Vessels/Single/Rows/HoldsHatchesTop';
import Cells from '../../../../../Vessels/Single/Rows/Cells';
import Areas from '../../../../../Vessels/Single/Rows/Areas';
import SpeedConsumptionV2 from '../../../../../Vessels/Single/Rows/SpeedConsumptionV2';
import Strength from '../../../../../Vessels/Single/Rows/Strength';
import StackWeight from '../../../../../Vessels/Single/Rows/StackWeight';
import OtherFields from '../../../../../Vessels/Single/Rows/OtherFields';
import Design from '../../../../../Vessels/Single/Rows/Design';
import DisponentOwner from '../../../../../Vessels/Single/Rows/DisponentOwner';
import Bunkers from '../../../../../Vessels/Single/Rows/Bunkers';
import Description from '../../../../../Vessels/Single/Rows/Description';
import LinerMeter from '../../../../../Vessels/Single/Rows/LinerMeter';
import GearedGrabbed from '../../../../../Vessels/Single/Rows/GearedGrabbed';
import Pumps from '../../../../../Vessels/Single/Rows/Pumps';
import LastCargo from '../../../../../Vessels/Single/Rows/LastCargo';
import CapacityTanker from '../../../../../Vessels/Single/Rows/CapacityTanker';
import Manifolds from '../../../../../Vessels/Single/Rows/Manifolds';
import CertificateOfFitness from '../../../../../Vessels/Single/Rows/CertificateOfFitness';
import { prepareExclToLoad } from '../../../../../Vessels/Single/Rows/withExclusions';
import Attachments from '../../../../../Vessels/Single/Rows/Attachments';

import { showNotification } from 'helpers';

import VesselShortInfo from './VesselShortInfo';
import { getPlainDeepKeysValues, calculateDeepPaths } from './utils';
import CollapsableSection from './CollapsableSection';
import RegisteredOwner from 'components/Vessels/Single/Rows/RegisteredOwner';
import { checkGrabs } from 'helpers/vessels';
import moment from 'moment';

const styles = {
    toggleLabelStyle: {
        color: orange900,
    },
    underlineStyle: {
        borderColor: orange500,
    },
};

const defaultCargo = {
    cargo: { _id: '', name: '' },
    date: null,
};

function scroll() {
    this.blur();
}

function getInitialState(opts) {
    return {
        confirmed: true,
        areas: {},
        speeds: {},
        strength: {
            tanktopByHolds: [''],
        },
        stackWeight: {},
        certificateOfFitness: [],
        consumptions: {
            laden: [],
            ballast: [],
            eco: [],
            portIdle: [],
            portWorking: [],
        },
        holds: { lowerDims: [], tweenDims: [] },
        hatches: { size: [] },
        holdsHatchesProducer: '',

        builderV2: {
            yard: { _id: '', name: '' },
            country: { _id: '', name: '' },
        },
        registerNumber: '',
        registerClasses: [{ _id: '', name: '' }],
        classNotation: '',
        piClubObject: { _id: '', name: '' },
        iacsRegister: false,
        typeByPurpose: undefined,
        typeByConstruction: undefined,
        typeBySpecialty: '',
        typeBySize: '',
        openHatch: null,
        boxShaped: null,
        dimensions: {
            loa: undefined,
            beam: undefined,
            depth: undefined,
            lbp: undefined,
            beamMoulded: undefined,
            depthMoulded: undefined,
            bowToCenterManifold: undefined,
            keelToMast: undefined,
            airdrftLightship: undefined,
            airdrftNormBallast: undefined,
            airdrftLoadSumDwt: undefined,
            wltohcBallast: undefined,
            wltohcDeball: undefined,
            bwtlhc: undefined,
            parallelBodyLoaded: undefined,
            parallelBodyFore: undefined,
            parallelBodyAft: undefined,
            sttbr: undefined,
            bwtbr: undefined,
            freshWaterAllowance: undefined,
            dtcr: undefined,
        },
        manifolds: {
            bcm: undefined,
            scm: undefined,
            betweenManifolds: undefined,
            list: [{
                number: undefined,
                size: undefined,
                commonLine: undefined,
            }],
        },
        bunkers: [{
            quantity: undefined,
            typeOfFuel: '',
        }],
        gearV2: {
            summary: [
                {
                    type: '',
                    quantity: undefined,
                    capacity: undefined,
                    outreach: undefined,
                    radius: undefined,
                    maxSWL: undefined,
                    combinable: false,
                },
            ],
        },
        geared: null,
        grabV2: {
            summary: [
                {
                    type: '',
                    quantity: '',
                    volume: '',
                },
            ],
        },
        grabbed: null,
        pumps: {
            cargo: [{
                type: '',
                quantity: '',
                capacity: '',
            }],
            ballast: [{
                type: '',
                quantity: '',
                capacity: '',
            }],
        },
        techEquipCertificate: {
            co2Fitted: null,
            a60BulkheadFitted: null,
            cementHolesCount: '',
            cementHolesDia: '',
            newPanama: null,
            cementHolesFitted: null,
            referPlugFitted: null,
            itfFitted: null,
            lakesFitted: null,
            strengthenHeavy: null,
            logsFitted: null,
            aussieFitted: null,
            iceClass: '',
            ventilation: '',
            ventilationFitted: null,
            imoApp: '',
            imoClass: '',
            imoFitted: null,
            bwts: null,
            coiled: null,
            containerFitted: null,
            carFitted: null,
            rampway: null,
            lxb: '',
            grainFitted: null,
            grainHoles: '',
            grainDia: '',
            cargoTankDryer: null,
            cargoCoolingSystem: null,
            crudeOilWashing: null,
            rcttms: null,
            rctpms: null,
            bowChainStopper: null,
            chainSize: '',
            ngs: null,
            ngsCapacity: '',
            vrs: null,
            vrsNumLines: '',
            bowThruster: null,
            bowThrusterNum: '',
            bowThrusterBhp: '',
            bowThrusterKw: '',
            stemThruster: null,
            stemThrusterNum: '',
            stemThrusterBhp: '',
            stemThrusterKw: '',
            igs: {
                fitted: null,
                systems: [{
                    type: '',
                    capacity: '',
                    percentage: '',
                }],
            },
            referPlugsAmount: undefined,
        },
        cargoExclusionV2Object: { _id: '', name: '' },
        cargoExclusionV2List: [],
        cargoExclusionsV2: [],
        lastCargo: [{
            cargoes: [
                _.cloneDeep(defaultCargo),
                _.cloneDeep(defaultCargo),
                _.cloneDeep(defaultCargo),
            ],
        }],
        deadWeight: {
            sLoaded: undefined,
            sDWT: undefined,
            sDWCC: undefined,
            sDraft: undefined,
            sTpc: undefined,
            sTpi: undefined,
            tLoaded: undefined,
            tDWT: undefined,
            tDWCC: undefined,
            tDraft: undefined,
            tTpc: undefined,
            tTpi: undefined,
            wLoaded: undefined,
            wDWT: undefined,
            wDWCC: undefined,
            wDraft: undefined,
            wTpc: undefined,
            wTpi: undefined,
            fLoaded: undefined,
            fDWT: undefined,
            fDWCC: undefined,
            fDraft: undefined,
            fTpc: undefined,
            fTpi: undefined,
        },
        rt: {
            gt: undefined,
            nt: undefined,
            suezGt: undefined,
            suezNt: undefined,
            panamaGt: undefined,
            panamaNt: undefined,
        },
        capacityV2: {
            grain: undefined,
            bale: undefined,
            teu: undefined,
            feu: undefined,
            constant: undefined,
            summary: [{
                hold: {
                    grain: undefined,
                    bale: undefined,
                    teu: undefined,
                    feu: undefined,
                },
                tweenDeck: {
                    grain: undefined,
                    bale: undefined,
                    teu: undefined,
                    feu: undefined,
                },
            }],
        },
        capacityTanker: {
            segregation: '',
            details: '',
            ttlCapacity: '',
            cargoGrades: '',
            tanks: [{
                port: '',
                starboard: '',
            }],
            slops: [{
                port: '',
                starboard: '',
            }],
            ballastTanks: [{
                port: '',
                starboard: '',
            }],
            cargoCapacity: '',
            slopsCapacity: '',
            ballastCapacity: '',
            wholeTank: false,
            coatingType: '',
            heating: {
                exchanger: null,
                medium: undefined,
                maxLoaded: '',
                maxMaintained: '',
            },
        },
        holdsV2: [],
        doubleHull: undefined,
        hullNumber: '',
        callSign: '',
        officialNumber: '',
        mmsi: '',
        cells: [{
            holds: {
                l: undefined,
                b: undefined,
                h: undefined,
                area: undefined,
            },
            tweenDecks: [
                {
                    l: undefined, b: undefined, h: undefined, area: undefined,
                },
                {
                    l: undefined, b: undefined, h: undefined, area: undefined,
                },
            ],
            hatches: [
                { l: undefined, b: undefined, area: undefined },
                { l: undefined, b: undefined, area: undefined },
            ],
        }],
        temporaryHohaAreas: {
            mainDeckSummArea: null,
            tweenDecksSummArea: null,
            hatchesSummArea: null,
        },
        speedConsumptionV2: [{
            mode: '',
            speed: undefined,
            ifo: {
                typeIfo: 'HFO 180',
                cons: undefined,
            },
            mdo: {
                typeMdo: 'MGO',
                cons: undefined,
            },
            lngCons: undefined,
        }],
        exNames: [],
        nationalities: [],


        flagObject: { _id: '', name: '' },
        flag: { _id: '', name: '' },
        managerObject: { _id: '', name: '' },
        manager: { _id: '', name: '' },
        registeredOwner: { _id: '', name: '' },
        homePortObject: { _id: '', name: '' },
        homePort: { _id: '', name: '' },

        name: undefined,
        imoNumber: undefined,
        type: '',
        image: undefined,
        blt: undefined,
        attachments: [],
        attachmentsArray: [],

        typeOfPage: 'new',
        engineLocation: undefined,
        engines: [{
            type: undefined,
            number: undefined,
            capacity: undefined,
            rpm: undefined,
            makeType: undefined,
        }],
        errors: [],

        modifiedFields: [],
        currentlyModifiedFields: [],
        purposeErrorField: {},
        toggleSpeedConsAll: {
            IFO: false,
            MDO: false,
        },
        windScale: undefined,
        description: undefined,
        design: { _id: '', name: '' },
        disponentOwner: { _id: '', name: '' },
        sanctions: [],
        ...opts,
    };
}

class SizesTable extends React.Component {
    constructor(props) {
        super(props);

        const stateOpts = {};

        stateOpts.showAddButton = props.hasOwnProperty('showAddButton') ? props.showAddButton : true;

        this.state = getInitialState(stateOpts);

        this.changeField = this.changeField.bind(this);
        this.changeAreas = this.changeAreas.bind(this);
        this.getError = this.getError.bind(this);
        this.changeAutoComplete = this.changeAutoComplete.bind(this);
        this.toggleIacsRegister = this.toggleIacsRegister.bind(this);
        this.toggleOpenHatch = this.toggleOpenHatch.bind(this);
        this.toggleBoxShaped = this.toggleBoxShaped.bind(this);
        this.changeHolds = this.changeHolds.bind(this);
        this.changeHatches = this.changeHatches.bind(this);
        this.clearError = this.clearError.bind(this);
        this.findType = this.findType.bind(this);
        this.sizeUpdate = this.sizeUpdate.bind(this);
        this.prepareToLoad = this.prepareToLoad.bind(this);
        this.sizeAdd = this.sizeAdd.bind(this);
        this.changeSizeArray = this.changeSizeArray.bind(this);
        this.getOldData = this.getOldData.bind(this);
        this.toggleModifySpeedCons = this.toggleModifySpeedCons.bind(this);
        this.changeGrabbed = this.changeGrabbed.bind(this);
        this.changeGeared = this.changeGeared.bind(this);
        this.updateWithModifiedSizes = this.updateWithModifiedSizes.bind(this);
    }

    getOldData(vesselData) {
        const vessel = { ...getInitialState(), ...vesselData };

        _.defaults(vessel.capacityTanker, getInitialState().capacityTanker);

        if (!vessel.holds.tweenDims && !vessel.holds.lowerDims) {
            vessel.holds = { ...getInitialState().holds, ...vessel.holds };
        }

        if (!vessel.grabV2.summary || !vessel.grabV2.summary.length) {
            vessel.grabV2 = getInitialState().grabV2;
        }

        if (!vessel.gearV2.summary || !vessel.gearV2.summary.length) {
            vessel.gearV2 = getInitialState().gearV2;
        }

        if (_.has(vessel.attachments[0], 'name')) {
            vessel.attachmentsArray = [];

            vessel.attachments.forEach((item) => {
                vessel.attachmentsArray.push(item);
            });

            vessel.attachments = [];

            vessel.attachmentsArray.forEach((item) => {
                vessel.attachments.push(item._id);
            });
        }

        if (!vessel.capacityV2.summary || !vessel.capacityV2.summary.length) {
            const { capacityV2: { summary } } = getInitialState();

            vessel.capacityV2.summary = summary;
        }

        for (const tank of vessel.lastCargo) {
            for (let i = tank.cargoes.length; i < 3; i++) {
                tank.cargoes.push(_.cloneDeep(defaultCargo));
            }
        }

        if (vessel.registerClass && vessel.registerClass._id && !vessel.registerClasses[0]._id) {
            vessel.registerClasses = [_.cloneDeep(vessel.registerClass)];
        }

        return vessel;
    }

    componentDidMount() {
        this.changeField({
            field: 'temporaryHohaAreas',
            value: {
                mainDeckSummArea: parseFloat(this.state.areas.mainDeck) || 0,
                tweenDecksSummArea: parseFloat(this.state.areas.tweenDeck) || 0,
            },
        });

        if (this.props.routeParams.id) {
            getVessel(this.props.routeParams.id)
                .then((response) => {
                    response.data.type = this.findType(response.data.type);

                    for (const item in response.data) {
                        const obj = response.data[item];
                        if (typeof obj === 'string') {
                            continue;
                        }

                        // remove empty objects
                        if (obj === null || obj === undefined || (Array.isArray(obj) && obj.length === 0) || (Object.keys(obj).length === 0 && obj.constructor === Object)) {
                            delete response.data[item];
                        }
                    }
                    const vessel = this.getOldData(response.data);

                    this.setState(vessel);
                });
        }
    }

    findType(type) {
        switch (type) {
            case 'CONT':
            case 'Fully Cellular Container':
                return 'CONT';
            case 'ROLO':
            case 'Passenger/Cargo Vessel':
            case 'Deck Cargo Carrier':
            case 'Ro-Ro/Lo-Lo':
            case 'Reefer/Ro-Ro Cargo':
            case 'Reefer/Pallets Carrier':
            case 'Ro-Ro/Container':
            case 'Product Carrier/Ro-Ro':
            case 'Barge Carrier':
                return 'ROLO';
            case 'RORO':
            case 'Pass./Car Ferry':
            case 'Ro-Ro Freight/Passenger':
            case 'Ro-Ro':
            case 'Pure Car Carrier':
            case 'Palletised Cargo Carrier':
                return 'RORO';
            case 'SID':
            case 'minibulk':
            case 'panamax':
            case 'Miscellaneous Dry Bulk':
            case 'Cement Carrier':
            case 'Aggregate Carrier':
            case 'Bulk Carrier':
            case 'Ore Carrier':
            case 'Ore/Oil Carrier':
            case 'Urea Carrier':
            case 'Open Hatch Carrier':
            case 'Chip Carrier':
            case 'Slurry Carrier':
            case 'handymax':
            case 'Ore & Sulphuric Acid Carrier':
            case 'Forest Product Carrier':
            case 'supramax':
            case 'overpanamax':
            case 'Salt Carrier':
            case 'capesize':
            case 'handysize':
                return 'SID';
            case 'TWEEN':
            case 'General Cargo':
            case 'Reefer':
            case 'Reefer/General Cargo':
            case 'Miscellaneous Cargo':
            case 'Multi-Purpose':
            case 'Multi-Purpose/Heavy Lift Cargo':
            case 'Products/Multi-Purpose Cargo':
            case 'Heavy Lift Cargo Vessel':
                return 'TWEEN/MPP';
            case 'Product Carrier':
            case 'Chemical Unknown Carrier':
            case 'Bunkering Vessel':
            case 'Chemical Bulk Tanker':
            case 'Chemical & Oil Carrier':
            case 'Chem Parcel Tanker':
            case 'Molten Sulphur Carrier':
            case 'Asphalt & Bitumen Carrier':
            case 'Tanker':
            case 'Water Carrier':
            case 'Edible Oil Carrier':
            case 'Sulphuric Acid Carrier':
            case 'Oil & Liquid Gas Carrier':
            case 'Fruit Juice Carrier':
            case 'Methanol Carrier':
            case 'Phosphoric Acid Carrier':
            case 'Shuttle Tanker':
            case 'Oil Recovery Tanker':
                return 'TANK';
            case 'Cruise Ship':
            case 'Landing Craft':
            case 'Pass./Car Catamaran Vessel':
            case 'Passenger Vessel':
            case 'Waste Disposal Carrier':
            case 'Livestock Carrier':
            case 'Limestone Carrier':
            case 'Reefer Fish Carrier':
                return 'OTHER';
        }

        return type;
    }

    checkGears(array) {
        return array.filter((item) => {
            if (item.combinable) {
                return true;
            }

            for (const key in item) {
                if (key !== 'combinable') {
                    return !!item[key];
                }
            }
        });
    }

    /** @param {{ field: string, value: unknown, type?: string, cb?: Function }} param0 */
    changeField({
        field, value, type, cb,
    }) {
        this.setState(produce((state) => {
            if (type === 'number' && value === '') {
                value = undefined;
            }

            if (
                (this.state.toggleSpeedConsAll.IFO || this.state.toggleSpeedConsAll.MDO) &&
                (field.endsWith('.typeIfo') || field.endsWith('.typeMdo'))
            ) {
                const { IFO: toggleIfo, MDO: toggleMdo } = this.state.toggleSpeedConsAll;
                const typeFuel = field.search(/mdo/) >= 0 ? 'mdo' : 'ifo';
                const speedConsCopy = _.cloneDeep(this.state.speedConsumptionV2);
                const modifiedFieldsCopy = new Set(_.cloneDeep(this.state.modifiedFields));

                typeFuel === 'ifo' && toggleIfo && speedConsCopy.forEach((item, index) => {
                    modifiedFieldsCopy.add(`speedConsumptionV2[${index}][ifo].typeIfo`);
                    item[typeFuel].typeIfo = value;
                });

                typeFuel === 'mdo' && toggleMdo && speedConsCopy.forEach((item, index) => {
                    modifiedFieldsCopy.add(`speedConsumptionV2[${index}][mdo].typeMdo`);
                    item[typeFuel].typeMdo = value;
                });

                _.set(state, 'speedConsumptionV2', speedConsCopy);
                this.setState({
                    currentlyModifiedFields: [...modifiedFieldsCopy],
                    modifiedFields: [...modifiedFieldsCopy],
                });
            }

            if (type === 'array') {
                state = _.set(state, field, [...state[field], value]);
            } else {
                state = _.set(state, field, value);
            }

            state.errors = state.errors.filter((error) => {
                if (!error.field) {
                    return false;
                }

                return error.field && !error.field.includes(error.field.replace(/\[|\]\./g, '.'));
            });
        }), () => {
            cb && cb();
        });

        this.setState({
            currentlyModifiedFields: _.uniq([...this.state.currentlyModifiedFields, field]),
        });
    }

    changeFieldsMultiple = (changes) => {
        let state = _.cloneDeep(this.state);

        if (!Array.isArray(changes)) {
            changes = [changes];
        }

        changes.forEach(({ field, value, type }) => {
            state = _.set(state, field, type && type === 'array' ? [value] : value);
            state.currentlyModifiedFields = _.uniq([...this.state.currentlyModifiedFields, field]);
        });

        this.setState(state);
    }

    changeModifiedMultiple = (modifications = []) => {
        const state = _.cloneDeep(this.state);

        const modificationKeys = [];

        modifications.forEach((modification) => {
            modificationKeys.push(Object.keys(modification)[0]);
        });

        state.currentlyModifiedFields = _.uniq([
            ...this.state.currentlyModifiedFields,
            ...modificationKeys,
        ]);

        this.setState(s => ({ ...s, currentlyModifiedFields: state.currentlyModifiedFields }));
    }

    changeAreas({ field, value, hatchesField }) {
        let { hatchesSummArea } = this.state.temporaryHohaAreas;
        hatchesSummArea = parseFloat(hatchesSummArea) || null;

        let {
            mainDeck, tweenDeck, weatherDeck,
        } = this.state.areas;
        mainDeck = parseFloat(mainDeck) || null;
        tweenDeck = parseFloat(tweenDeck) || null;
        weatherDeck = parseFloat(weatherDeck) || null;
        value = parseFloat(value) || null;

        if (field === 'areas.mainDeck') {
            this.setState(state => ({
                areas: {
                    ...state.areas,
                    mainDeck: value,
                    total: (value || 0) + (tweenDeck || 0) + (weatherDeck || 0) + (hatchesSummArea || 0),
                },
                currentlyModifiedFields: _.uniq([...state.currentlyModifiedFields, 'areas.mainDeck']),
            }));
        } else if (field === 'areas.tweenDeck') {
            this.setState(state => ({
                areas: {
                    ...state.areas,
                    tweenDeck: value,
                    total: (value || 0) + (mainDeck || 0) + (weatherDeck || 0) + (hatchesSummArea || 0),
                },
                currentlyModifiedFields: _.uniq([...state.currentlyModifiedFields, 'areas.tweenDeck']),
            }));
        } else if (hatchesField) {
            let state = _.cloneDeep(this.state);
            state = _.set(state, field, value);
            this.setState(state, () => {
                const { cells } = this.state;
                hatchesSummArea = 0;
                for (const cell of cells) {
                    hatchesSummArea += ((parseFloat(cell.hatches[0].area) || 0) + (parseFloat(cell.hatches[1].area) || 0));
                }

                this.changeField({
                    field: 'temporaryHohaAreas.hatchesSummArea',
                    value: hatchesSummArea,
                });
                this.setState(state => ({
                    areas: {
                        ...state.areas,
                        total: (hatchesSummArea || 0) + (mainDeck || 0) + (tweenDeck || 0) + (weatherDeck || 0)/* + (total || 0)*/,
                    },
                }));
            });
        } else {
            let state = _.cloneDeep(this.state);
            state = _.set(state, field, value);
            let { weatherDeck } = state.areas;
            const { cells, temporaryHohaAreas } = state;
            let mainDeck = 0;
            let tweenDeck = 0;
            weatherDeck = parseFloat(weatherDeck) || 0;

            for (const cell of cells) {
                mainDeck += (state.temporaryHohaAreas.mainDeckSummArea + (parseFloat(cell.holds.area) || 0));
                tweenDeck += (state.temporaryHohaAreas.tweenDecksSummArea || 0) + (parseFloat(cell.tweenDecks[0].area) || 0) + (parseFloat(cell.tweenDecks[1].area) || 0);
            }

            state.areas.mainDeck = mainDeck;
            state.areas.tweenDeck = tweenDeck;
            state.areas.total = state.areas.mainDeck + state.areas.tweenDeck + weatherDeck + hatchesSummArea;

            state.errors = state.errors.filter((error) => {
                if (!error.field) {
                    return false;
                }

                return !error.field.includes(field);
            });

            this.setState(state);
        }

        if (field === 'areas.weatherDeck') {
            this.setState(state => ({
                currentlyModifiedFields: _.uniq([...state.currentlyModifiedFields, 'areas.weatherDeck']),
            }));
        }
    }

    getError(field) {
        if (!this.state.errors.length) {
            return '';
        }

        const errorObject = this.state.errors.find(error => error.field === field);

        return errorObject ? errorObject.messages[0] : '';
    }

    clearError(field) {
        const errors = this.state.errors.filter((error) => {
            if (!error.field) {
                return false;
            }

            return !error.field.includes(field);
        });

        this.setState({
            errors,
        });
    }

    changeAutoComplete(type, object) {
        let state = this.state;

        state = _.set(state, type, object._id);
        state = _.set(state, `${type}Object`, {
            name: object.name,
            _id: object._id,
        });

        this.setState(state, () => {
            this.clearError(type);
        });

        this.changeField({
            field: type,
            value: { _id: object._id, name: object.name },
        });
    }

    toggleIacsRegister(e, value) {
        this.changeField({
            field: 'iacsRegister',
            value,
        });
    }

    toggleOpenHatch(e, value) {
        this.changeField({
            field: 'openHatch',
            value,
        });
    }

    toggleBoxShaped(e, value) {
        this.changeField({
            field: 'boxShaped',
            value,
        });
    }

    toggleModifySpeedCons(type) {
        this.setState({
            toggleSpeedConsAll: {
                ...this.state.toggleSpeedConsAll,
                [type]: !this.state.toggleSpeedConsAll[type],
            },
        });
    }

    changeHolds(value) {
        value = Math.abs(parseInt(value));

        const state = this.state;
        state.holds.quantity = value;

        const lowerDims = _.cloneDeep(state.holds.lowerDims);
        const tweenDims = _.cloneDeep(state.holds.tweenDims);

        state.holds.lowerDims = this.changeSizeArray(lowerDims, value);
        state.holds.tweenDims = this.changeSizeArray(tweenDims, value);

        state.currentlyModifiedFields = _.uniq([...this.state.currentlyModifiedFields, 'holds.quantity']);

        state.errors = state.errors.filter((error) => {
            if (!error.field) {
                return false;
            }

            return !error.field.includes('holds.quantity');
        });

        this.setState(state);
    }

    changeHatches(value) {
        value = Math.abs(parseInt(value));

        const state = this.state;
        state.hatches.quantity = value;

        const size = _.cloneDeep(state.hatches.size);

        state.hatches.size = this.changeSizeArray(size, value);

        state.currentlyModifiedFields = _.uniq([...this.state.currentlyModifiedFields, 'hatches.quantity']),

            state.errors = state.errors.filter((error) => {
                if (!error.field) {
                    return false;
                }

                return !error.field.includes('hatches.quantity');
            });

        this.setState(state);
    }

    changeSizeArray(array, value) {
        const diff = Math.abs(array.length - value);

        if (value > array.length) {
            for (let i = 0; i <= diff - 1; i++) {
                array.push({});
            }
        } else if (value < array.length) {
            array.splice(value, diff);
        }

        return array;
    }

    /**
     * The function serializes the vessel data into a backend JSON.
     */
    prepareToLoad(vessel, add) {
        if (vessel.errors.length > 0) {
            const el = document.getElementsByName(vessel.errors[0].field)[0];
            el.scrollIntoView();

            return;
        }

        const {
            builderV2: defaultBuilderV2,
            flagObject: defaultFlagObject,
            managerObject: defaultManagerObject,
            homePortObject: defaultHomePortObject,
        } = getInitialState();

        vessel.flagObject = vessel.flag ? vessel.flag : defaultFlagObject;
        vessel.flag = _.has(vessel, 'flag._id') && vessel.flag._id !== '' ? vessel.flag._id : this.state.flag;
        vessel.owner = _.has(vessel, 'owner._id') && vessel.owner._id !== '' ? vessel.owner._id : this.state.owner;
        vessel.registeredOwner = this.state.registeredOwnerObject;
        vessel.manager = _.has(vessel, 'managerObject._id') && vessel.managerObject._id !== '' ? vessel.managerObject._id : undefined;
        vessel.managerObject = this.state.manager ? this.state.manager : defaultManagerObject;
        vessel.homePort = _.has(vessel, 'homePortObject._id') && vessel.homePortObject._id !== '' ? vessel.homePortObject._id : undefined;
        vessel.homePortObject = this.state.homePort ? this.state.homePort : defaultHomePortObject;
        vessel.builderV2.country = this.state.builderV2.country || defaultBuilderV2.country;
        vessel.builderV2.country = this.state.builderV2.country ? this.state.builderV2.country._id : defaultBuilderV2.country._id;
        vessel.images = this.state.images ? this.state.images.map(im => im._id) : undefined;

        if (!vessel.capacityV2.summary) {
            vessel.capacityV2.summary = [];
        }

        if (vessel.rt) {
            vessel.rt.panamaNt = vessel.rt.panamaNt || undefined;
            vessel.rt.suezGt = vessel.rt.suezGt || undefined;
            vessel.rt.suezNt = vessel.rt.suezNt || undefined;
            vessel.rt.nt = vessel.rt.nt || undefined;
            vessel.rt.gt = vessel.rt.gt || undefined;
        }

        if (vessel.cargoExclusionsV2.length) {
            vessel.cargoExclusionsV2 = prepareExclToLoad(vessel.cargoExclusionsV2);
        }
        if (vessel.tradingRestrictions && vessel.tradingRestrictions.length) {
            vessel.tradingRestrictions = prepareExclToLoad(vessel.tradingRestrictions);
        }

        if (vessel.dimensions) {
            for (const [key, value] of Object.entries(vessel.dimensions)) {
                if (!value) {
                    vessel.dimensions[key] = undefined;
                }
            }
        }

        if (vessel.engines) {
            for (let i = 0; i < vessel.engines.length; i++) {
                const engine = vessel.engines[i];
                for (const [key, value] of Object.entries(engine)) {
                    if (!value) {
                        engine[key] = undefined;
                    }
                }
            }
        }

        if (vessel.deadWeight) {
            for (const [key, value] of Object.entries(vessel.deadWeight)) {
                vessel.deadWeight[key] = value ? parseFloat(value) : undefined;
            }
        }

        if (vessel.techEquipCertificate) {
            for (const [key, value] of Object.entries(vessel.techEquipCertificate)) {
                if (!value) {
                    vessel.techEquipCertificate[key] = undefined;
                }
            }
            const { igs } = vessel.techEquipCertificate;
            if (igs) {
                igs.fitted = igs.fitted || undefined;
                if (igs.systems) {
                    igs.systems = igs.systems
                        .filter(s => s.type || s.capacity || s.percentage)
                        .map(s => ({
                            type: s.type || undefined,
                            capacity: parseFloat(s.capacity) || undefined,
                            percentage: parseFloat(s.percentage) || undefined,
                        }));
                }
            }
        }

        if (vessel.areas) {
            vessel.areas.mainDeck = vessel.areas.mainDeck || undefined;
            vessel.areas.tweenDeck = vessel.areas.tweenDeck || undefined;
            vessel.areas.weatherDeck = vessel.areas.weatherDeck || undefined;
            vessel.areas.total = vessel.areas.total || undefined;
        }

        if (vessel.strength) {
            vessel.strength.maxTt = vessel.strength.maxTt || undefined;
            vessel.strength.maxTween = vessel.strength.maxTween || undefined;
            vessel.strength.maxWeather = vessel.strength.maxWeather || undefined;
        }

        if (vessel.stackWeight) {
            vessel.stackWeight['20hold'] = vessel.stackWeight['20hold'] || undefined;
            vessel.stackWeight['20deck'] = vessel.stackWeight['20deck'] || undefined;
            vessel.stackWeight['40hold'] = vessel.stackWeight['40hold'] || undefined;
            vessel.stackWeight['40deck'] = vessel.stackWeight['40deck'] || undefined;
        }

        vessel.cells = vessel.cells.filter((item) => {
            const holdsLen = Object.values(item.holds).filter(_item => _item).length;
            const tweenDecksLen0 = Object.values(item.tweenDecks[0]).filter(_item => _item).length;
            const tweenDecksLen1 = Object.values(item.tweenDecks[1]).filter(_item => _item).length;

            const hatchesLen0 = Object.values(item.hatches[0]).filter(_item => _item).length;
            const hatchesLen1 = Object.values(item.hatches[1]).filter(_item => _item).length;

            return holdsLen || tweenDecksLen0 || tweenDecksLen1 || hatchesLen0 || hatchesLen1;
        });

        if (vessel.cells) {
            vessel.cells.forEach((cell) => {
                cell.holds.l = parseFloat(cell.holds.l) || undefined;
                cell.holds.b = parseFloat(cell.holds.b) || undefined;
                cell.holds.h = parseFloat(cell.holds.h) || undefined;
                cell.holds.area = parseFloat(cell.holds.area) || undefined;

                cell.tweenDecks[0].l = parseFloat(cell.tweenDecks[0].l) || undefined;
                cell.tweenDecks[0].b = parseFloat(cell.tweenDecks[0].b) || undefined;
                cell.tweenDecks[0].h = parseFloat(cell.tweenDecks[0].h) || undefined;
                cell.tweenDecks[0].area = parseFloat(cell.tweenDecks[0].area) || undefined;

                cell.tweenDecks[1].l = parseFloat(cell.tweenDecks[1].l) || undefined;
                cell.tweenDecks[1].b = parseFloat(cell.tweenDecks[1].b) || undefined;
                cell.tweenDecks[1].h = parseFloat(cell.tweenDecks[1].h) || undefined;
                cell.tweenDecks[1].area = parseFloat(cell.tweenDecks[1].area) || undefined;

                cell.hatches[0].l = parseFloat(cell.hatches[0].l) || undefined;
                cell.hatches[0].b = parseFloat(cell.hatches[0].b) || undefined;
                cell.hatches[0].area = parseFloat(cell.hatches[0].area) || undefined;

                cell.hatches[1].l = parseFloat(cell.hatches[1].l) || undefined;
                cell.hatches[1].b = parseFloat(cell.hatches[1].b) || undefined;
                cell.hatches[1].area = parseFloat(cell.hatches[1].area) || undefined;
            });
        }

        if (vessel.speedConsumptionV2) {
            vessel.speedConsumptionV2.forEach((val) => {
                val.speed = parseFloat(val.speed) || undefined;
                val.ifo.cons = parseFloat(val.ifo.cons) || undefined;
                val.mdo.cons = parseFloat(val.mdo.cons) || undefined;
                val.lngCons = parseFloat(val.lngCons) || undefined;
            });
        }

        vessel.speedConsumptionV2 = vessel.speedConsumptionV2.filter(item => item.mode);

        if (vessel.capacityV2) {
            vessel.capacityV2.constant = parseFloat(vessel.capacityV2.constant) || undefined;
            vessel.capacityV2.grain = parseFloat(vessel.capacityV2.grain) || undefined;
            vessel.capacityV2.bale = parseFloat(vessel.capacityV2.bale) || undefined;
            vessel.capacityV2.teu = parseFloat(vessel.capacityV2.teu) || undefined;
            vessel.capacityV2.feu = parseFloat(vessel.capacityV2.feu) || undefined;

            vessel.capacityV2.summary.forEach((item) => {
                if (!item.hold) item.hold = {};
                item.hold.grain = parseFloat(item.hold.grain) || undefined;
                item.hold.bale = parseFloat(item.hold.bale) || undefined;
                item.hold.teu = parseFloat(item.hold.teu) || undefined;
                item.hold.feu = parseFloat(item.hold.feu) || undefined;

                if (!item.tweenDeck) item.tweenDeck = {};
                item.tweenDeck.grain = parseFloat(item.tweenDeck.grain) || undefined;
                item.tweenDeck.bale = parseFloat(item.tweenDeck.bale) || undefined;
                item.tweenDeck.teu = parseFloat(item.tweenDeck.teu) || undefined;
                item.tweenDeck.feu = parseFloat(item.tweenDeck.feu) || undefined;
            });
        }

        vessel.gearV2.summary = this.checkGears(vessel.gearV2.summary);
        vessel.grabV2.summary = checkGrabs(vessel.grabV2.summary);

        vessel.capacityV2.summary = this.checkCapacity(vessel.capacityV2.summary);

        if (vessel.grabV2) {
            vessel.grabV2.summary.forEach((grab) => {
                grab.type = grab.type || '';
                grab.quantity = grab.quantity || undefined;
                grab.volume = grab.volume || undefined;
            });
        }

        if (vessel.holds) {
            vessel.holds.quantity = vessel.holds.quantity || undefined;

            if (vessel.holds.lowerDims && vessel.holds.lowerDims.length) {
                vessel.holds.lowerDims.forEach((dim) => {
                    dim.l = dim.l || undefined;
                    dim.b = dim.b || undefined;
                    dim.h = dim.h || undefined;
                });
            }

            if (vessel.holds.tweenDims && vessel.holds.tweenDims.length) {
                vessel.holds.tweenDims.forEach((dim) => {
                    dim.l = dim.l || undefined;
                    dim.b = dim.b || undefined;
                    dim.h = dim.h || undefined;
                });
            }
        }

        if (vessel.hatches) {
            if (vessel.hatches.hatchType === 'Mc Greegor') {
                vessel.hatches.hatchType = 'Mc Gregor';
            }
            if (vessel.hatches.size && vessel.hatches.size.length) {
                vessel.hatches.size.forEach((dim) => {
                    dim.l = dim.l || undefined;
                    dim.b = dim.b || undefined;
                });
            }
        }

        vessel.imoClass = vessel.imoClass || undefined;

        if (vessel.builderV2 && vessel.builderV2.yard === '') {
            vessel.builderV2.yard = undefined;
        }

        if (vessel.bunkers.length > 0) {
            vessel.bunkers = vessel.bunkers.filter(item => item.quantity && item.typeOfFuel);
        }

        if (!vessel.disponentOwner._id && !vessel.disponentOwner.name) {
            delete vessel.disponentOwner;
        }

        if (vessel.pumps && vessel.pumps.cargo) {
            vessel.pumps.cargo = vessel.pumps.cargo
                .filter(p => p.type || p.quantity || p.capacity);
        }
        if (vessel.pumps && vessel.pumps.ballast) {
            vessel.pumps.ballast = vessel.pumps.ballast
                .filter(p => p.type || p.quantity || p.capacity);
        }
        if (vessel.registerClasses) {
            vessel.registerClasses = vessel.registerClasses
                .filter(c => c.name && (c._id || c.iacsRegister === true || c.iacsRegister === false))
                .map(c => ({
                    _id: c._id || undefined,
                    name: c.name || undefined,
                    iacsRegister: (c.iacsRegister === true || c.iacsRegister === false)
                        ? c.iacsRegister
                        : undefined,
                }));
            vessel.registerClass = undefined;
        }
        if (vessel.capacityTanker.tanks) {
            vessel.capacityTanker.tanks = vessel.capacityTanker.tanks
                .filter(t => t.port || t.starboard);
        }
        if (vessel.capacityTanker.slops) {
            vessel.capacityTanker.slops = vessel.capacityTanker.slops
                .filter(t => t.port || t.starboard);
        }
        if (vessel.capacityTanker.ballastTanks) {
            vessel.capacityTanker.ballastTanks = vessel.capacityTanker.ballastTanks
                .filter(t => t.port || t.starboard);
        }
        if (vessel.manifolds && vessel.manifolds.list) {
            vessel.manifolds.list = vessel.manifolds.list
                .filter(m => m.number || m.size || m.commonLine);
        }
        if (vessel.lastCargo) {
            vessel.lastCargo = vessel.lastCargo
                .map(tank => ({
                    cargoes: tank.cargoes
                        .filter(c => c.cargo._id && c.date)
                        .map(c => ({
                            ...c,
                            cargo: c.cargo._id.toString(),
                        })),
                }));
        }
        if (vessel.certificateOfFitness) {
            vessel.certificateOfFitness = vessel.certificateOfFitness
                .map(c => c._id);
        }
        if (vessel.strength && vessel.strength.tanktopByHolds) {
            vessel.strength.tanktopByHolds = vessel.strength.tanktopByHolds
                .map(s => parseInt(s, 10))
                .filter(s => !isNaN(s));
        }

        vessel.capacityTanker.wholeTank = !!vessel.capacityTanker.wholeTank;

        delete vessel.modifiedFields;

        delete vessel.modifiedFields;
        delete vessel.registeredOwnerObject;
        // field from old vessel model
        delete vessel.draft;
        delete vessel.tonnage;
        delete vessel.gears;
        delete vessel.consumptions;
        delete vessel.dw;
        delete vessel.capacity;
        return vessel;
    }

    sizeUpdate() {
        let vessel = _.cloneDeep(this.state);
        if (!vessel.typeByPurpose) {
            this.setState({
                purposeErrorField: {
                    borderColor: red500,
                },
            });
            showNotification('Type by Purpose is required', 'error');
        } else {
            vessel = this.prepareToLoad(vessel);
            vessel && this.props.updateVessel(vessel);
        }
    }

    sizeAdd() {
        let vessel = _.cloneDeep(this.state);
        if (!vessel.typeByPurpose) {
            this.setState({
                purposeErrorField: {
                    borderColor: red500,
                },
            });
            showNotification('Type by Purpose is required', 'error');
        } else {
            vessel = this.prepareToLoad(vessel, true);
            vessel && this.props.addVessel(vessel);
        }
    }

    changeGeared(value) {
        const change = {
            geared: value,
            currentlyModifiedFields: _.uniq([...this.state.currentlyModifiedFields, 'geared']),
        };

        if (!value) {
            const { grabbed, gearV2, grabV2 } = getInitialState();

            change.gearV2 = gearV2;
            change.grabV2 = grabV2;
            change.grabbed = grabbed;
        }

        this.setState(change);
    }

    changeGrabbed(value) {
        const change = {
            grabbed: value,
            currentlyModifiedFields: _.uniq([...this.state.currentlyModifiedFields, 'grabbed']),
        };

        if (!value) {
            const { grabV2 } = getInitialState();
            change.grabV2 = grabV2;
        }

        this.setState(change);
    }

    checkCapacity(array) {
        return array.filter((item) => {
            const {
                hold: {
                    grain: hg, bale: hb, teu: ht, feu: hf,
                },
                tweenDeck: {
                    grain: tg, bale: tb, teu: tt, feu: tf,
                },
            } = item;

            return hg || hb || ht || hf || tg || tb || tt || tf;
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.modifySizes !== this.props.modifySizes) {
            this.updateWithModifiedSizes(this.props.modifySizes);
        }

        /* delete scroll event listener from input elements */
        const inputs = document.querySelectorAll('input[type=number]');

        inputs.forEach((input) => {
            input.removeEventListener('mousewheel', scroll);
            input.addEventListener('mousewheel', scroll);
        });
    }

    updateWithModifiedSizes(modifySizes) {
        let arrayIndex;
        switch (modifySizes.field) {
            case 'gearV2':
                modifySizes.value = _.omit(modifySizes.value, ['approved', 'rejected']);
                if (this.state.gearV2.summary.length === 1 && !this.state.gearV2.summary[0].type) {
                    this.changeFieldsMultiple([
                        ...getPlainDeepKeysValues({ gearV2: { summary: [modifySizes.value] } }).map((o) => {
                            const v = Object.entries(o)[0];
                            return { field: v[0], value: v[1] };
                        }),
                        { field: 'geared', value: true },
                    ]);
                } else {
                    if (this.state.gearV2.summary.some((g) => {
                        const {
                            type, quantity, capacity, outreach, maxSWL,
                        } = modifySizes.value;
                        return g.type === type && g.quantity === quantity &&
                            g.capacity === capacity && g.outreach === outreach &&
                            g.maxSWL === maxSWL;
                    })) {
                        return;
                    }
                    const emp = [];
                    emp.length = this.state.gearV2.summary.length;
                    this.changeFieldsMultiple([
                        ...getPlainDeepKeysValues({
                            gearV2: {
                                summary: [
                                    ...emp,
                                    modifySizes.value,
                                ],
                            },
                        }).map((o) => {
                            const v = Object.entries(o)[0];
                            return { field: v[0], value: v[1] };
                        }),
                        {
                            geared: true,
                        },
                    ]);
                }

                arrayIndex = this.state.gearV2.summary.length === 1 &&
                    !this.state.gearV2.summary[0].type ? 0 : this.state.gearV2.summary.length;
                this.changeModifiedMultiple([
                    ...calculateDeepPaths({
                        arrayIndex,
                        stateField: 'gearV2.summary',
                        value: modifySizes.value,
                    }),
                    ...calculateDeepPaths({
                        stateField: 'geared',
                        value: true,
                    }),
                ]);
                break;
            case 'grabV2':
                if (this.state.grabV2.summary.some((g) => {
                    const { type, volume, quantity } = modifySizes.value;
                    return g.type === type && g.volume === volume &&
                        g.quantity === quantity;
                })) {
                    return;
                }
                modifySizes.value = _.omit(modifySizes.value, ['approved', 'rejected']);
                if (this.state.grabV2.summary.length === 1 && !this.state.grabV2.summary[0].type) {
                    this.changeFieldsMultiple([
                        ...getPlainDeepKeysValues({ grabV2: { summary: [modifySizes.value] } }).map((o) => {
                            const v = Object.entries(o)[0];
                            return { field: v[0], value: v[1] };
                        }),
                        { field: 'geared', value: true },
                        { field: 'grabbed', value: true },
                    ]);
                } else {
                    const emp = [];
                    emp.length = this.state.grabV2.summary.length;
                    this.changeFieldsMultiple([
                        ...getPlainDeepKeysValues({
                            grabV2: {
                                summary: [
                                    ...emp,
                                    modifySizes.value,
                                ],
                            },
                        }).map((o) => {
                            const v = Object.entries(o)[0];
                            return { field: v[0], value: v[1] };
                        }),
                        {
                            geared: true,
                        },
                    ]);
                }

                arrayIndex = this.state.grabV2.summary.length === 1 &&
                    !this.state.grabV2.summary[0].type ? 0 : this.state.grabV2.summary.length;
                this.changeModifiedMultiple([
                    ...calculateDeepPaths({
                        arrayIndex,
                        stateField: 'grabV2.summary',
                        value: modifySizes.value,
                    }),
                    ...calculateDeepPaths({
                        stateField: 'geared',
                        value: true,
                    }),
                    ...calculateDeepPaths({
                        stateField: 'grabbed',
                        value: true,
                    }),
                ]);
                break;
            case 'speedConsumptionV2':
                if (this.state.speedConsumptionV2.some((g) => {
                    const {
                        mode, speed, ifo, mdo,
                    } = modifySizes.value;
                    return g.mode === mode && g.speed === speed &&
                        ifo && (g.ifo.typeIfo === ifo.typeIfo && g.ifo.cons === ifo.cons) &&
                        mdo && (g.mdo.typeIfo === mdo.typeIfo && g.mdo.cons === mdo.cons);
                })) {
                    return;
                }
                if (this.state.speedConsumptionV2.length === 1 && !this.state.speedConsumptionV2[0].mode) {
                    this.changeFieldsMultiple([{
                        field: modifySizes.field,
                        value: [Object.assign({}, getInitialState().speedConsumptionV2[0], modifySizes.value)],
                    }]);
                    this.changeModifiedMultiple(calculateDeepPaths({
                        arrayIndex: 0,
                        stateField: 'speedConsumptionV2',
                        value: modifySizes.value,
                    }));
                } else {
                    this.changeFieldsMultiple([
                        {
                            field: modifySizes.field,
                            value: [
                                ...this.state.speedConsumptionV2,
                                Object.assign({}, getInitialState().speedConsumptionV2[0], modifySizes.value),
                            ],
                        },
                    ]);
                    this.changeModifiedMultiple(calculateDeepPaths({
                        arrayIndex: this.state.speedConsumptionV2.length,
                        stateField: 'speedConsumptionV2',
                        value: modifySizes.value,
                    }));
                }
                break;
            case 'typeByPurpose':
            case 'typeByConstruction':
            case 'typeBySpecialty':
                this.changeFieldsMultiple([{
                    field: modifySizes.field,
                    value: modifySizes.value,
                }]);
                this.changeModifiedMultiple(calculateDeepPaths({
                    stateField: modifySizes.field,
                    value: modifySizes.value,
                }));
                break;
            case 'deadWeight':
                this.changeFieldsMultiple([{
                    field: 'deadWeight',
                    value: {
                        ...this.state.deadWeight,
                        ...modifySizes.value,
                    },
                }]);
                this.changeModifiedMultiple(calculateDeepPaths({
                    stateField: 'deadWeight',
                    value: modifySizes.value,
                }));
                break;
            case 'dimensions':
                this.changeFieldsMultiple([
                    {
                        field: 'dimensions',
                        value: {
                            ...this.state.dimensions,
                            ...modifySizes.value,
                        },
                    },
                    {
                        field: 'dimensionsV2',
                        value: {
                            ...this.state.dimensionsV2,
                            ...modifySizes.value,
                        },
                    },
                ]);
                this.changeModifiedMultiple(calculateDeepPaths({
                    stateField: 'dimensions',
                    value: modifySizes.value,
                }));
                break;
            case 'rt':
                this.changeFieldsMultiple([{
                    field: 'rt',
                    value: {
                        ...this.state.rt,
                        ...modifySizes.value,
                    },
                }]);
                this.changeModifiedMultiple(calculateDeepPaths({
                    stateField: 'rt',
                    value: modifySizes.value,
                }));
                break;
            case 'techEquipCertificate':
                this.changeFieldsMultiple([{
                    field: 'techEquipCertificate',
                    value: {
                        ...this.state.techEquipCertificate,
                        ...modifySizes.value,
                    },
                }]);
                this.changeModifiedMultiple(calculateDeepPaths({
                    stateField: 'techEquipCertificate',
                    value: modifySizes.value,
                }));
                break;
            case 'cells':
                let isSame = true;

                const modifyArray = Object.values(modifySizes.value);

                for (let i = 0; i < modifyArray.length; i++) {
                    const g = this.state.cells[i];
                    const { holds = {}, tweenDecks, hatches } = modifyArray[i];
                    if (!(
                        holds && g.holds.l === holds.l && g.holds.b === holds.b && g.holds.h === holds.h &&
                        g.tweenDecks[0].l === tweenDecks[0].l && g.tweenDecks[0].b === tweenDecks[0].b &&
                        g.tweenDecks[0].h === tweenDecks[0].h &&

                        g.tweenDecks[1].l === tweenDecks[1].l && g.tweenDecks[1].b === tweenDecks[1].b &&
                        g.tweenDecks[1].h === tweenDecks[1].h &&

                        g.hatches[0].l === hatches[0].l && g.hatches[0].b === hatches[0].b &&
                        g.hatches[1].l === hatches[1].l && g.hatches[1].b === hatches[1].b
                    )) {
                        isSame = false;
                        break;
                    }
                }

                if (isSame) return;

                for (const val of Object.values(modifySizes.value)) {
                    if (!val.holds) val.holds = {};
                }
                const updatedCells = [];

                const vals = Object.values(modifySizes.value);

                for (let i = 0; i < vals.length; i++) {
                    updatedCells.push(Object.assign({}, this.state.cells[i] || {}, vals[i] || {}));
                }

                this.changeFieldsMultiple({
                    field: 'cells',
                    value: updatedCells,
                });

                this.changeModifiedMultiple(calculateDeepPaths({
                    arrayIndex: 0,
                    stateField: 'cells',
                    value: updatedCells,
                }));
                break;
            case 'flag':
                this.changeFieldsMultiple([{
                    field: 'flag',
                    value: {
                        ...modifySizes.value,
                    },
                },
                {
                    field: 'flagObject',
                    value: {
                        ...modifySizes.value,
                    },
                }]);
                this.changeModifiedMultiple(calculateDeepPaths({
                    stateField: 'flag',
                    value: modifySizes.value,
                }));
                break;
            case 'registerClass':
            case 'registerClasses':
                let v = modifySizes.value;

                if (modifySizes.field === 'registerClass') {
                    v = [v];
                }

                this.changeFieldsMultiple([{
                    field: 'registerClasses',
                    value: _.cloneDeep(v),
                }]);
                this.changeModifiedMultiple(calculateDeepPaths({
                    stateField: 'registerClasses',
                    value: _.cloneDeep(v),
                }));
                break;
            case 'piClub':
                this.changeFieldsMultiple([{
                    field: 'piClub',
                    value: {
                        ...modifySizes.value,
                    },
                },
                {
                    field: 'piClubObject',
                    value: {
                        ...modifySizes.value,
                    },
                }]);
                this.changeModifiedMultiple([
                    ...calculateDeepPaths({
                        stateField: 'piClub',
                        value: modifySizes.value,
                    }),
                    ...calculateDeepPaths({
                        stateField: 'piClubObject',
                        value: modifySizes.value,
                    }),
                ]);
                break;
            case 'capacityV2':
                this.changeFieldsMultiple([
                    {
                        field: 'capacityV2',
                        value: {
                            ...this.state.capacityV2,
                            ...modifySizes.value,
                        },
                    },
                    {
                        field: 'capacity',
                        value: {
                            ...this.state.capacity,
                            ..._.omit(modifySizes.value, ['summary']),
                        },
                    },
                ]);
                this.changeModifiedMultiple([
                    ...calculateDeepPaths({
                        stateField: 'capacityV2',
                        value: modifySizes.value,
                    }),
                ]);
                break;
            case 'boxShaped':
            case 'openHatch':
                this.changeFieldsMultiple([{
                    field: modifySizes.field,
                    value: modifySizes.value,
                }]);
                break;
            default:
                break;
        }
    }

    renderMarkForDeletion = () => (
        this.state.markForDeletion ? 
            <div 
                className='paper-block margin-bottom center-xs' 
                style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    color: '#d32f2f', 
                    fontWeight: 'bold',
                    padding: '15px 10px',
                    border: '2px solid #d32f2f',
                    backgroundColor: '#ffebee',
                    borderRadius: '4px',
                    position: 'relative',
                    gap: '5px',
                }}
            >
                <div className='name-block absolute small-name' style={{ color: '#d32f2f', backgroundColor: '#ffebee' }}>
                    Deletion info
                </div>
                {this.state.markForDeletion && <div>Marked for Deletion</div>}
                {this.state.markForDeletionDate && <div>Marked on: {moment(this.state.markForDeletionDate).format('DD-MM-YYYY HH:mm')}</div>}
            </div> :
            null
    )

    render() {
        const {
            confirmed,
            areas,
            strength,
            stackWeight,
            certificateOfFitness,
            holds,
            hatches,
            holdsHatchesProducer,
            builderV2,
            registerNumber,
            registerClasses,
            classNotation,
            piClubObject,
            piClub,
            typeByPurpose,
            typeByConstruction,
            typeBySpecialty,
            typeBySize,
            openHatch,
            boxShaped,
            gearV2,
            geared,
            grabV2,
            grabbed,
            pumps,
            techEquipCertificate,
            cargoExclusionV2Object,
            cargoExclusionV2List,
            cargoExclusionsV2,
            deadWeight,
            rt,
            dimensions,
            manifolds,
            capacityV2,
            capacityTanker,
            cells,
            temporaryHohaAreas,
            speedConsumptionV2,
            flagObject,
            flag,
            managerObject,
            manager,
            registeredOwner,
            homePortObject,
            homePort,
            name,
            imoNumber,
            blt,
            exNames,
            nationalities,
            typeOfPage,
            engineLocation,
            engines,
            modifiedFields,
            currentlyModifiedFields,
            purposeErrorField,
            toggleSpeedConsAll,
            windScale,
            bunkers,
            description,
            design,
            disponentOwner,
            linerMeter,
            showAddButton,
            doubleHull,
            hullNumber,
            callSign,
            officialNumber,
            mmsi,
            lastCargo,
            attachmentsArray,
        } = this.state;

        const { builderV2: defaultBuilderV2 } = getInitialState();

        const allModifiedFields = _.uniq([...modifiedFields, ...currentlyModifiedFields]);

        const linerMeterDisabled = !(new RegExp('ro-(ro|lo)', 'i').test(typeBySpecialty));

        return (
            <div className='col-xs-12'>
                <div className='paper-block margin-bottom'>
                    <div className='top-bar' style={{ background: '#fff', margin: '-18px 0 -7px 0' }}>
                        <RaisedButton
                            backgroundColor='#00bcd4'
                            labelStyle={{ color: '#fff', fontWeight: 'bold' }}
                            label='UPDATE'
                            onClick={this.sizeUpdate}
                            disabled={!this.state._id}
                        />
                        {
                            showAddButton &&
                            <RaisedButton
                                backgroundColor='#00bcd4'
                                labelColor='#fff'
                                label='CREATE'
                                onClick={this.sizeAdd}
                                disabled={!!this.state._id}
                            />
                        }
                    </div>
                </div>
                {this.renderMarkForDeletion()}
                {
                    this.props.numberSizeTable || this.props.numberSizeTable === 0 ?
                        <VesselShortInfo
                            numberSizeTable={this.props.numberSizeTable}
                        /> : null
                }
                <div className='paper-block margin-bottom'>
                    <div className='row'>
                        <div className='col-xs-5'>
                            <Name
                                name={name}
                                confirmed={!confirmed}
                                changeField={this.changeField}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                        <ExNames
                            exNames={exNames}
                            confirmed={!confirmed}
                            changeField={this.changeField}
                            getError={this.getError}
                            modifiedFields={allModifiedFields}
                            underStyle={styles.underlineStyle}
                        />
                    </div>
                    <div className='row'>
                        <div className='col-xs-5'>
                            <ImoNumber
                                imoNumber={imoNumber}
                                confirmed={!confirmed}
                                typeOfPage={typeOfPage}
                                changeField={this.changeField}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                        <Nationalities
                            value={nationalities}
                            confirmed={!confirmed}
                            changeField={this.changeField}
                            getError={this.getError}
                            modifiedFields={allModifiedFields}
                            underStyle={styles.underlineStyle}
                        />
                    </div>
                    <div className='row'>
                        <div className='col-xs-3'>
                            <Blt
                                blt={blt}
                                confirmed={!confirmed}
                                changeField={this.changeField}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                        <div className='col-xs-9'>
                            <div className='row'>
                                <div className='col-xs-2'>
                                    <div style={{ margin: '40px 0 0', textAlign: 'right' }}>Builder:</div>
                                </div>
                                <div className='col-xs-5'>
                                    <BuilderYard
                                        getError={this.getError}
                                        changeField={this.changeField}
                                        yard={builderV2.yard || builderV2.yard || defaultBuilderV2.yard}
                                        confirmed={!confirmed}
                                        modifiedFields={allModifiedFields}
                                        underStyle={styles.underlineStyle}
                                    />
                                </div>
                                <div className='col-xs-5'>
                                    <BuilderCountry
                                        getError={this.getError}
                                        changeAutoComplete={this.changeAutoComplete}
                                        country={builderV2.country || builderV2.country || defaultBuilderV2.country}
                                        confirmed={!confirmed}
                                        modifiedFields={allModifiedFields}
                                        underStyle={styles.underlineStyle}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-xs-4'>
                            <Flag
                                changeAutoComplete={this.changeAutoComplete}
                                getError={this.getError}
                                flagObject={flag._id ? flag : flagObject}
                                confirmed={!confirmed}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                        <div className='col-xs-4'>
                            <PortOfRegistry
                                homePortObject={homePort && homePort._id ? homePort : homePortObject}
                                confirmed={!confirmed}
                                changeAutoComplete={this.changeAutoComplete}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                        <div className='col-xs-4'>
                            <TextField
                                name="registerNumber"
                                disabled={!confirmed}
                                value={registerNumber}
                                floatingLabelText='Registry №'
                                onChange={e => this.changeField(/** @type {any} */({
                                    field: 'registerNumber',
                                    value: /** @type {HTMLInputElement} */ (e.currentTarget).value,
                                }))}
                                fullWidth
                            />
                        </div>
                    </div>
                    <RegisterClasses
                        registerClasses={registerClasses}
                        changeField={this.changeFieldsMultiple}
                        confirmed={confirmed}
                        getError={this.getError}
                        modifiedFields={allModifiedFields}
                        underStyle={styles.underlineStyle}
                        clearError={this.clearError}
                    />
                    <TextField
                        name="classNotation"
                        disabled={!confirmed}
                        value={classNotation}
                        floatingLabelText='Class notation'
                        onChange={e => this.changeField(/** @type {any} */({
                            field: 'classNotation',
                            value: /** @type {HTMLInputElement} */ (e.currentTarget).value,
                        }))}
                        fullWidth
                    />
                    <div className='row'>
                        <div className='col-xs-4'>
                            <PIClub
                                piClubObject={piClubObject.name.length || !piClub ? piClubObject : piClub}
                                changeField={this.changeField}
                                confirmed={!confirmed}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                                clearError={this.clearError}
                            />
                        </div>
                        <div className='col-xs-4'>
                            <RegisteredOwner
                                _registeredOwnerObject={registeredOwner}
                                confirmed={!confirmed}
                                changeAutoComplete={this.changeAutoComplete}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                        <div className='col-xs-4'>
                            <Manager
                                managerObject={manager && manager._id ? manager : managerObject}
                                confirmed={!confirmed}
                                changeAutoComplete={this.changeAutoComplete}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-xs-4">
                            <Design
                                design={design}
                                confirmed={!confirmed}
                                changeField={this.changeField}
                                getError={this.getError}
                            />
                        </div>
                        <div className='col-xs-4'>
                            <DisponentOwner
                                changeField={this.changeField}
                                confirmed={!confirmed}
                                disponentOwner={disponentOwner}
                            />
                        </div>
                        <div className='col-xs-2' style={{ display: 'flex' }}>
                            <SelectField
                                value={openHatch}
                                onChange={(e, i, value) => this.changeFieldsMultiple([{ field: 'openHatch', value }])}
                                disabled={!confirmed}
                                name='openHatch'
                                floatingLabelText='Open Hatch'
                                labelStyle={allModifiedFields && allModifiedFields.includes('openHatch') ? styles.toggleLabelStyle : null}
                                underlineStyle={allModifiedFields && allModifiedFields.includes('openHatch') ? styles.underlineStyle : null}
                                autoWidth
                                fullWidth
                            >
                                <MenuItem value={null} primaryText={undefined} />
                                <MenuItem value primaryText='Yes' />
                                <MenuItem value={false} primaryText='No' />
                            </SelectField>
                        </div>
                        <div className='col-xs-2' style={{ display: 'flex' }}>
                            <SelectField
                                value={boxShaped}
                                onChange={(e, i, value) => this.changeFieldsMultiple([{ field: 'boxShaped', value }])}
                                disabled={!confirmed}
                                name='boxShaped'
                                floatingLabelText='Box Shaped'
                                labelStyle={allModifiedFields && allModifiedFields.includes('boxShaped') ? styles.toggleLabelStyle : null}
                                underlineStyle={allModifiedFields && allModifiedFields.includes('boxShaped') ? styles.underlineStyle : null}
                                autoWidth
                                fullWidth
                            >
                                <MenuItem value={null} primaryText={undefined} />
                                <MenuItem value primaryText='Yes' />
                                <MenuItem value={false} primaryText='No' />
                            </SelectField>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-xs-4">
                            <Checkbox
                                style={{ margin: '40px 0 0' }}
                                label='Double hull'
                                checked={doubleHull}
                                disabled={!confirmed}
                                onCheck={() => this.changeField(/** @type {any} */({
                                    field: 'doubleHull',
                                    value: !doubleHull,
                                }))}
                            />
                        </div>
                        <div className='col-xs-4'>
                            <TextField
                                name="hullNumber"
                                disabled={!confirmed}
                                value={hullNumber}
                                floatingLabelText='Hull number'
                                onChange={e => this.changeField(/** @type {any} */({
                                    field: 'hullNumber',
                                    value: /** @type {HTMLInputElement} */ (e.currentTarget).value,
                                }))}
                                fullWidth
                            />
                        </div>
                        <div className='col-xs-4'>
                            <TextField
                                name="callSign"
                                disabled={!confirmed}
                                value={callSign}
                                floatingLabelText='Call sign'
                                onChange={e => this.changeField(/** @type {any} */({
                                    field: 'callSign',
                                    value: /** @type {HTMLInputElement} */ (e.currentTarget).value,
                                }))}
                                fullWidth
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-xs-4">
                            <TextField
                                name="officialNumber"
                                disabled={!confirmed}
                                value={officialNumber}
                                floatingLabelText='Official number'
                                onChange={e => this.changeField(/** @type {any} */({
                                    field: 'officialNumber',
                                    value: /** @type {HTMLInputElement} */ (e.currentTarget).value,
                                }))}
                                fullWidth
                            />
                        </div>
                        <div className="col-xs-4">
                            <TextField
                                name="mmsi"
                                disabled={!confirmed}
                                value={mmsi}
                                floatingLabelText='MMSI'
                                onChange={e => this.changeField(/** @type {any} */({
                                    field: 'mmsi',
                                    value: /** @type {HTMLInputElement} */ (e.currentTarget).value,
                                }))}
                                fullWidth
                            />
                        </div>
                        <div className='col-xs-4'>
                            <LinerMeter
                                linerMeter={linerMeter}
                                linerMeterDisabled={linerMeterDisabled}
                                changeFieldsMultiple={this.changeFieldsMultiple}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-xs-3'>
                            <TypeByPurpose
                                type={typeByPurpose}
                                confirmed={!confirmed}
                                changeField={this.changeFieldsMultiple}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={purposeErrorField.hasOwnProperty('borderColor') ? purposeErrorField : styles.underlineStyle}
                                purposeErrorField={purposeErrorField}
                            />
                        </div>
                        <div className='col-xs-3'>
                            <TypeBySpecialty
                                typeBySpecialty={typeBySpecialty}
                                confirmed={!confirmed}
                                changeField={this.changeFieldsMultiple}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                                typeByPurpose={typeByPurpose}
                            />
                        </div>
                        <div className='col-xs-3'>
                            <TypeByConstruction
                                type={typeByConstruction}
                                confirmed={!confirmed}
                                changeField={this.changeField}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                        <div className='col-xs-3'>
                            <TypeBySize
                                type={typeBySize}
                                confirmed={confirmed}
                                changeField={this.changeFieldsMultiple}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                    </div>
                </div>
                <div className='paper-block margin-bottom'>
                    <div className='row'>
                        <div className='col-xs-1'>
                            <span className='name-block static huge-name'>GEAR:</span>
                        </div>
                        <div
                            className="col-xs-3 col-xs-offset-8"
                        >
                            <GearedGrabbed
                                confirmed={confirmed}
                                fieldName='geared'
                                gearedGrabbed={geared}
                                onChange={this.changeGeared}
                                modifiedFields={allModifiedFields}
                                styles={styles}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-xs-12'>
                            <GearV2
                                gearV2={gearV2}
                                confirmed={!confirmed}
                                changeField={this.changeFieldsMultiple}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                                toggleLabelStyle={styles.toggleLabelStyle}
                            />
                        </div>
                    </div>
                </div>
                <CollapsableSection
                    title="GRABS:"
                    titleControl={
                        <GearedGrabbed
                            confirmed={confirmed}
                            fieldName='grabbed'
                            gearedGrabbed={grabbed}
                            onChange={this.changeGrabbed}
                            modifiedFields={allModifiedFields}
                            styles={styles}
                        />
                    }
                >
                    <GrabV2
                        grabs={grabV2}
                        confirmed={!confirmed}
                        changeField={this.changeFieldsMultiple}
                        getError={this.getError}
                        modifiedFields={allModifiedFields}
                        underStyle={styles.underlineStyle}
                    />
                </CollapsableSection>
                <CollapsableSection title="PUMPS:">
                    <div className='row'>
                        <div className='col-xs-12'>
                            <Pumps
                                type='cargo'
                                pumps={pumps.cargo}
                                confirmed={!confirmed}
                                changeField={this.changeFieldsMultiple}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-xs-12'>
                            <Pumps
                                type='ballast'
                                pumps={pumps.ballast}
                                confirmed={!confirmed}
                                changeField={this.changeFieldsMultiple}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                    </div>
                </CollapsableSection>
                <div className='paper-block margin-bottom'>
                    <div className='row'>
                        <div className='col-xs-12'>
                            <TechEquipCertificate
                                confirmed={!confirmed}
                                techEquipCertificate={techEquipCertificate}
                                changeField={this.changeFieldsMultiple}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                                toggleLabelStyle={styles.toggleLabelStyle}
                            />
                        </div>
                    </div>
                </div>
                <div className='paper-block margin-bottom'>
                    <span className='name-block static huge-name'>TONNAGE, reg tons</span>
                    <div className='row'>
                        <div className='col-xs-12'>
                            <Tonnage
                                confirmed={!confirmed}
                                rt={rt}
                                changeField={this.changeField}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                    </div>
                </div>
                <div className='paper-block margin-bottom'>
                    <span className='name-block static huge-name'>CARGO EXCLUSIONS</span>
                    <div className='row'>
                        <div className='col-xs-12'>
                            <CargoExclussionsV2
                                cargoExclusionV2Object={cargoExclusionV2Object}
                                cargoExclusionV2List={cargoExclusionV2List.length || !cargoExclusionsV2 ? cargoExclusionV2List : cargoExclusionsV2}
                                cargoExclusionsV2={cargoExclusionsV2}
                                confirmed={!confirmed}
                                changeField={this.changeField}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                    </div>
                </div>
                <CollapsableSection title="Last 3 Cargo" initiallyCollapsed>
                    <LastCargo
                        lastCargo={lastCargo}
                        disabled={!confirmed}
                        changeField={this.changeField}
                        getError={this.getError}
                        modifiedFields={allModifiedFields}
                        underStyle={styles.underlineStyle}
                    />
                </CollapsableSection>
                <div className='paper-block margin-bottom'>
                    <div className='row'>
                        <div className='col-xs-6'>
                            <span className='name-block static huge-name'>DEADWEIGHT / OTHER:</span>
                        </div>
                        <div className="col-xs-3 col-xs-offset-3">
                            <NumberField
                                name='capacityV2.constant'
                                floatingLabelText='Constant, mt'
                                style={{ margin: '-35px 0 -25px 0' }}
                                value={capacityV2.constant || ''}
                                fullWidth
                                floatNumber
                                errorText={this.getError('capacityV2.constant')}
                                onChange={(e, value) => {
                                    this.changeFieldsMultiple([{
                                        field: 'capacityV2.constant',
                                        value,
                                        type: 'number',
                                    }]);
                                }}
                                underlineStyle={modifiedFields && modifiedFields.includes('capacityV2.constant') ? styles.underlineStyle : null}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-xs-12'>
                            <Deadweight
                                deadWeight={deadWeight}
                                confirmed={!confirmed}
                                changeField={this.changeField}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                                clearError={this.clearError}
                            />
                        </div>
                    </div>
                </div>
                <CollapsableSection title="CAPACITY GENERAL">
                    <CapacityV2
                        capacityV2={capacityV2}
                        confirmed={!confirmed}
                        changeField={this.changeField}
                        getError={this.getError}
                        modifiedFields={allModifiedFields}
                        underStyle={styles.underlineStyle}
                    />
                </CollapsableSection>
                <CollapsableSection title="HO/HA">
                    <HoldsHatchesTop
                        holds={holds}
                        confirmed={!confirmed}
                        hatches={hatches}
                        holdsHatchesProducer={holdsHatchesProducer}
                        changeHolds={this.changeHolds}
                        changeHatches={this.changeHatches}
                        changeField={this.changeField}
                        getError={this.getError}
                        modifiedFields={allModifiedFields}
                        underStyle={styles.underlineStyle}
                    />
                    <Cells
                        cells={cells}
                        changeAreas={this.changeAreas}
                        changeField={this.changeField}
                        confirmed={!confirmed}
                        getError={this.getError}
                        temporaryHohaAreas={temporaryHohaAreas}
                        modifiedFields={allModifiedFields}
                        underStyle={styles.underlineStyle}
                    />
                    <Areas
                        areas={areas}
                        confirmed={!confirmed}
                        changeAreas={this.changeAreas}
                        changeField={this.changeField}
                        getError={this.getError}
                        modifiedFields={allModifiedFields}
                        underStyle={styles.underlineStyle}
                    />
                </CollapsableSection>
                <CollapsableSection title='CAPACITY TANKER'>
                    <CapacityTanker
                        capacityTanker={capacityTanker}
                        confirmed={!confirmed}
                        changeField={this.changeField}
                        getError={this.getError}
                        modifiedFields={allModifiedFields}
                        underStyle={styles.underlineStyle}
                    />
                </CollapsableSection>
                <div className='paper-block margin-bottom'>
                    <span className='name-block static huge-name'>DIMENSIONS, m</span>
                    <div className='row'>
                        <div className='col-xs-12'>
                            <Dimensions
                                dimensions={dimensions}
                                confirmed={!confirmed}
                                changeField={this.changeField}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                    </div>
                </div>
                <CollapsableSection title="MANIFOLDS">
                    <Manifolds
                        manifolds={manifolds}
                        confirmed={!confirmed}
                        changeField={this.changeField}
                        getError={this.getError}
                        modifiedFields={allModifiedFields}
                        underStyle={styles.underlineStyle}
                    />
                </CollapsableSection>
                <div className='paper-block margin-bottom'>
                    <div className='row'>
                        <div className='col-xs-3'>
                            <span className='name-block static huge-name'>SPEED & CONSUMPTION:</span>
                        </div>
                        <div className='col-xs-offset-5' style={{ marginTop: '2px' }}>
                            <span className='name-block static huge-name' style={{ color: '#b0b0b0', fontSize: '14px' }}>Modify all:</span>
                        </div>
                        <div className='col-xs-1'>
                            <Toggle
                                name='modifyAllIfo'
                                label='IFO'
                                disabled={!confirmed}
                                toggled={toggleSpeedConsAll.IFO}
                                onToggle={() => this.toggleModifySpeedCons('IFO')}
                            />
                        </div>
                        <div className='col-xs-1'>
                            <Toggle
                                name='modifyAllMdo'
                                label='MDO'
                                disabled={!confirmed}
                                toggled={toggleSpeedConsAll.MDO}
                                onToggle={() => this.toggleModifySpeedCons('MDO')}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-xs-12'>
                            <SpeedConsumptionV2
                                speedConsumptionV2={speedConsumptionV2}
                                confirmed={!confirmed}
                                changeField={this.changeField}
                                getError={this.getError}
                                modifiedFields={allModifiedFields}
                                underStyle={styles.underlineStyle}
                            />
                        </div>
                    </div>
                </div>
                <div className="paper-block margin-bottom">
                    <span className="name-block static huge-name">
                        BUNKERS
                    </span>
                    <Bunkers
                        bunkers={bunkers}
                        confirmed={!confirmed}
                        changeField={this.changeField}
                        getError={this.getError}
                    />
                </div>
                <CollapsableSection title='PERMISSIBLE LOADS'>
                    <Strength
                        strength={strength}
                        confirmed={!confirmed}
                        changeField={this.changeField}
                        getError={this.getError}
                        modifiedFields={allModifiedFields}
                        underStyle={styles.underlineStyle}
                    />
                    <StackWeight
                        stackWeight={stackWeight}
                        confirmed={!confirmed}
                        changeField={this.changeField}
                        getError={this.getError}
                        modifiedFields={allModifiedFields}
                        underStyle={styles.underlineStyle}
                    />
                </CollapsableSection>
                <CollapsableSection title='CERTIFICATE OF FITNESS'>
                    <CertificateOfFitness
                        confirmed={confirmed}
                        certificateOfFitness={certificateOfFitness}
                        changeField={this.changeField}
                    />
                </CollapsableSection>
                <div className='paper-block margin-bottom'>
                    <span className='name-block static huge-name'>OTHER FIELDS</span>
                    <OtherFields
                        confirmed={!confirmed}
                        engineLocation={engineLocation}
                        engines={engines}
                        windScale={windScale}
                        changeField={this.changeField}
                        getError={this.getError}
                        modifiedFields={allModifiedFields}
                        underStyle={styles.underlineStyle}
                    />
                </div>
                <div className="paper-block margin-bottom">
                    <span className="name-block static huge-name">
                        DESCRIPTION
                    </span>
                    <Description
                        confirmed={!confirmed}
                        description={description}
                        changeField={this.changeField}
                        getError={this.getError}
                    />
                </div>
                <div className='paper-block margin-bottom' style={{ paddingTop: '10px' }}>
                    <Attachments
                        attachments={attachmentsArray}
                        changeField={this.changeField}
                        confirmed={confirmed}
                    />
                </div>
            </div>
        );
    }
}

export default connect(
    /** @param {any} param0 */
    ({ vessel }) => ({
        vessel,
    }),
    dispatch => bindActionCreators({
        updateVessel,
        addVessel,
        notificationPurposeRequired,
        saveVessel,
        clearVessel,
    }, dispatch),
)(SizesTable);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Size/Sidebar/Size/SizesTable.jsx